import React from 'react';
// Data
import { linkButtonArray } from '../../utils/data/LinksData';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';

function LinksPageMainContainer() {
  return (
    <main role='main' className='pt-6 pb-12 full_shadow_black_invert'>
      <section className='grid justify-center mx-auto gap-y-4 w-fit'>
        {linkButtonArray.map((btn, index) => (
          <a
            key={index}
            href={btn.link}
            className={`flex items-center gap-3 cursor-pointer bg-colour3 border-2 border-solid border-colour5 hover:bg-colour1/30 neon_button px-6 py-2 w-full text-center rounded text-colour2 hover:text-colour4 ${
              !btn.link ? 'hidden' : ''
            }`}
            aria-label={`Visit ${btn.text}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            <span className='inline-grid text-colour7 place-items-center h-7 w-7'>
              {btn.icon}
            </span>
            <div className='text-center w-full'>
              <span>{btn.text}</span>
            </div>
          </a>
        ))}
      </section>

      {/* CTA */}
      <SocialMediaCtaComponent />
    </main>
  );
}

export default LinksPageMainContainer;
